var _excluded = ["contact"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import Decorator from "@evertrue/client-decorator";
import PropTypes from "prop-types";
import ContactDisplayCard from "./contact-display-card";

var ContactCard = function ContactCard(_ref) {
  var contact = _ref.contact,
      rest = _objectWithoutProperties(_ref, _excluded);

  var formattedName = Decorator.Contacts.getFullName(contact);
  var roleWithYear = Decorator.Profile.getRoleWithYear(contact);
  return /*#__PURE__*/React.createElement(ContactDisplayCard, _extends({
    formattedName: formattedName,
    roleWithYear: roleWithYear,
    contact: contact
  }, rest));
};

ContactCard.propTypes = {
  contact: PropTypes.object
};
ContactCard.defaultProps = {
  contact: {}
};
ContactCard.displayName = "ContactCard";
export default ContactCard;